import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { cleanMaskedNumber } from '@/utilities'
import { handleError } from '@/store/handle-error'

export const PEAdditionalIdentifiersCardActions = {
  initPeAdditionalIdentifiersCard: ({ commit }, index) => {
    commit('setPeAdditionalIdentifiersCardLock', { index, lock: true })
  },
  peAdditionalIdentifiersCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        identifiers: {
          party_id: party.id,
          kind: section.kind,
          value: cleanMaskedNumber(section.value),
          note: section.note,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeAdditionalIdentifiersCardLock', { index, lock: true })
        commit('pePatchParty', {
          identifiers: updatedParty.identifiers || [],
        })
      }).
      catch(handleError)
  },
  peAdditionalIdentifiersCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/identifiers/${section.id}`).
      then(({ data }) => {
        commit('setPeAdditionalIdentifiersCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'identifiers',
          value: data,
        })
      }).
      catch(handleError)
  },
  peAdditionalIdentifiersCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        identifiers: {
          party_id: party.id,
          kind: section.kind,
          value: cleanMaskedNumber(section.value),
          note: section.note,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeAdditionalIdentifiersCardLock', { index, lock: true })
        commit('pePatchParty', {
          identifiers: updatedParty.identifiers || [],
        })
      }).
      catch(handleError)
  },
  peAdditionalIdentifiersCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          identifiers: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeAdditionalIdentifiersCardLock', { index, lock: true })
        commit('pePatchParty', {
          identifiers: updatedParty.identifiers || [],
        })
      }).
      catch(handleError)
  },
  peAdditionalIdentifiersCardAddSection: ({ commit }) => {
    commit('setPeAdditionalIdentifiersCardLock', { index: 'new', lock: false })
    commit('addPeAdditionalIdentifiersCardSection', {
      id: null,
      kind: '',
      value: '',
      note: '',
    })
  },
}

export const PEAdditionalIdentifiersCardMutations = {
  setPeAdditionalIdentifiersCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.AdditionalIdentifiersCard) {
      Vue.set(state.partyEdit.partySections, 'AdditionalIdentifiersCard', {})
    }
    Vue.set(state.partyEdit.partySections.AdditionalIdentifiersCard, index, lock)
  },
  addPeAdditionalIdentifiersCardSection: (state, section) => {
    state.partyEdit.party.identifiers.push(section)
  },
  peAddictionalIdentifiersCardCreateUndo: state => state.partyEdit.party.identifiers.pop(),

}

export const PEAdditionalIdentifiersCardGetters = {
  peAdditionalIdentifiersCardLock: state => index => state.partyEdit.partySections.AdditionalIdentifiersCard[index],
  peAddictionalIdentifiersCardHasNewSection: (_, getters) => !!getters.
    peParty.
    identifiers?.
    find(identifier => identifier.id === null),
}
